<template>
  <div :bordered='false'>
    <div class='table-page-search-wrapper'>

      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>

          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t('platformCollection.name_of_collector')">
              <!--    <a-input :placeholder="$t('enter') + ' '+ $t('platformCollection.name_of_collector')"-->
              <!--    v-model='queryParam.userName'></a-input>-->
              <a-select
                v-model='queryParam.userName'
                optionFilterProp="children"
                showSearch
                allowClear
              >
                <a-select-option v-for='item in CollectorNameList' :key='item.value' :value='item.value'>
                  {{ item.key }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="'催收员账号'">
              <a-input :placeholder="$t('enter') + ' 催收员账号'" v-model='queryParam.sysmobile'></a-input>
            </a-form-item>
          </a-col>
          <a-col :md='10' :sm='10'>
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'createTime')">
              <a-range-picker
                v-model='queryParam.endTime'
                format='YYYY-MM-DD'
                style='width: 100%;' />
            </a-form-item>
          </a-col>
          <a-col :md='10' :sm='10'>
            <a-form-item :label="$t(I18N_KEY.COLLECTION + 'settleTime')">
              <a-range-picker
                v-model='queryParam.settleTime'
                format='YYYY-MM-DD'
                style='width: 100%;' />
            </a-form-item>
          </a-col>

          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t('platformCollection.department')">
              <a-select
                v-model='queryParam.departmentId'
                @change='onChange'
              >
                <a-select-option v-for='item in departmentList' :key='item.id'>
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t('platformCollection.grouping')">
              <a-select
                v-model='queryParam.groupId'
              >
                <a-select-option v-for='item in groupList' :key='item.id'>
                  {{ item.groupName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t('platformCollection.collection_stage')">
              <a-select default-value='' style='width: 190px' v-model='queryParam.normalConfigId'>
                <a-select-option v-for='item in normalConfigList' :key='item.id'>
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t(I18N_KEY.ORDER + 'custType')">
              <a-select default-value='' style='width: 120px' v-model='queryParam.custType'>
                <a-select-option value=''>
                  全部
                </a-select-option>
                <a-select-option value='1'>
                  新户
                </a-select-option>
                <a-select-option value='2'>
                  老户
                </a-select-option>
              </a-select>
            </a-form-item>
            <!--<a-form-item :label="$t(I18N_KEY + 'loanStatus')">-->
            <!--<dict-select-->
            <!--v-model="queryParam.loanStatus"-->
            <!--:dict-code="DICT_CODE.LOAN_STATUS"-->
            <!--:begin="[{ value: '', label: '全部', labelEn: 'All' }]"-->
            <!--:placeholder="$t('select')"-->
            <!--/>-->
            <!--</a-form-item>-->
          </a-col>

          <!--<a-col :md="6" :sm="8">-->
          <!--<a-form-item label="分组">-->
          <!--<a-cascader :options="groupOptions" placeholder="Please select" @change="onChange" />-->
          <!--</a-form-item>-->
          <!--</a-col>-->


          <a-col :md='6' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset')
                }}</a-button>
              <a-button type='primary' @click='downLoadData' icon='search' style='margin-left: 8px'>{{ $t('exportFile')
                }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>


      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        bordered>
      </a-table>


    </div>
    <v-modal
      v-model='visible'
      :title="$t('order.collectionDetail')">
      <div style='padding: 20px;'>
        <collection-detail
          v-if='visible'
          :orderId='orderId'
          :custInfoId='custInfoId'
          :taskId='taskId'
          :auditDrawer='false'
          @close='visible = false;' />
      </div>
    </v-modal>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { queryBackPerformance, getCollectorName } from '@/webpublicapi/collection'
import { getCollectionListDepartment } from '@/webpublicapi/group'
import { getSysGroup } from '@/webpublicapi/platformCollection'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import moment from 'moment'
import vModal from '../modules/Modal'
import exportFile from '@/webpublicapi/exportFile'
import CollectionDetail from './CollectionDetail'
import { getAllNormalConfig } from '@/webpublicapi/normalConfig'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  COLLECTION: 'collection.'
}

export default {
  name: 'AllApprovalTask',
  components: {
    Dict,
    DictSelect,
    vModal,
    CollectionDetail
  },
  data() {
    return {
      CollectorNameList: [],
      I18N_KEY,
      toggleSearchStatus: false,
      visible: false,
      orderId: undefined,
      custInfoId: undefined,
      taskId: undefined,
      exportParams: '',
      // 分页参数
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      groupList: [],
      departmentList: [],
      normalConfigList: [],
      groupOptions: [
        {
          value: 'zhejiang',
          label: 'Zhejiang',
          children: [
            {
              value: 'hangzhou',
              label: 'Hangzhou',
              children: [
                {
                  value: 'xihu',
                  label: 'West Lake'
                }
              ]
            }
          ]
        },
        {
          value: 'jiangsu',
          label: 'Jiangsu',
          children: [
            {
              value: 'nanjing',
              label: 'Nanjing',
              children: [
                {
                  value: 'zhonghuamen',
                  label: 'Zhong Hua Men'
                }
              ]
            }
          ]
        }
      ],
      // 查询条件
      queryParam: {
        'endTime': undefined,
        'settleTime': undefined,
        'userName': '',
        'normalConfigId': '',
        'sysmobile': '',
        'groupId': ''
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '催收员账号',
          align: 'left',
          dataIndex: 'mobile'
        },
        {
          title: this.$t('collection.userName'),
          align: 'left',
          dataIndex: 'userName'
        },
        {
          title: this.$t('collection.userId'),
          align: 'left',
          dataIndex: 'userId'
        },
        {
          title: this.$t('collection.groupName'),
          align: 'left',
          dataIndex: 'groupName'
        },
        {
          title: 'T0正常',
          align: 'left',
          dataIndex: 't0CountV1'
        },
        {
          title: 'T0展期',
          align: 'left',
          dataIndex: 't0CountExtV1'
        },
        {
          title: 'S1正常',
          align: 'left',
          dataIndex: 'firstOverdueCountV1'
        },
        {
          title: 'S1展期',
          align: 'left',
          dataIndex: 'firstOverdueCountExtV1'
        },
        {
          title: 'S2正常',
          align: 'left',
          dataIndex: 'secOverdueCountV1'
        },
        {
          title: 'S2展期',
          align: 'left',
          dataIndex: 'secOverdueCountExtV1'
        },
        {
          title: 'S3正常',
          align: 'left',
          dataIndex: 's3OverdueCountV1'
        },
        {
          title: 'S3展期',
          align: 'left',
          dataIndex: 's3OverdueCountExtV1'
        },
        {
          title: 'S4正常',
          align: 'left',
          dataIndex: 'thridOverdueCountV1'
        },
        {
          title: 'S4展期',
          align: 'left',
          dataIndex: 'thridOverdueCountExtV1'
        }
      ]
    }
  },
  created() {
    this.getDict()
    // this.loadData();
    getSysGroup().then(res => {
      this.groupList = res.data || []
    })

    getCollectionListDepartment().then(res => {
      this.departmentList = res.data || []
    })
    getAllNormalConfig().then(res => {
      this.normalConfigList = res.data || []
    })

    //催收员名称
    getCollectorName().then(res => {
      console.log('res-->', res.data)
      let keys = Object.keys(res.data)
      for (const key of keys) {
        this.CollectorNameList.push({
          key: key,// s1test1
          value: res.data[key]
        })
      }
      console.log('催收员res--->this.CollectorNameList ', this.CollectorNameList)
    })
  },
  methods: {
    CollectorNameListChange(e) {
      console.log('下拉框发生变化啦！', e)
      // this.userName = e
    },
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    searchQuery() {
      this.loadData()
    },
    loadData(arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      // if (arg === 1) {
      //   this.form.pageNum = 1
      // }
      this.loading = true
      var params = this.getQueryParams()// 查询条件
      queryBackPerformance(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          // this.total = res.data.total
          this.dataSource = res.data || []
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    getQueryParams() {
      const { endTime } = this.queryParam
      const { settleTime } = this.queryParam
      const data = {
        ...this.queryParam,
        settleDateStart: (settleTime && settleTime.length) ? this.transformTime(settleTime[0]) : undefined,
        settleDateEnd: (settleTime && settleTime.length) ? this.transformTime(settleTime[1]) : undefined,
        endDateStart: (endTime && endTime.length) ? this.transformTime(endTime[0]) : undefined,
        endDateEnd: (endTime && endTime.length) ? this.transformTime(endTime[1]) : undefined
      }
      delete data.settleTime
      delete data.endTime
      var param = Object.assign({}, data)
      // param.pageNum = this.form.pageNum;
      // param.pageSize = this.form.pageSize;
      return filterObj(param)
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.endTime = undefined
      that.queryParam.settleTime = undefined
      that.queryParam.userName = ''
      that.loadData(this.form.pageNum)
    },
    changeModal(visible) {
      this.visible = visible
    },
    downLoadData() {
      var params = this.getQueryParams('')// 查询条件
      const file = {
        fileUrl: '/api/web/collectionTask/backPerformanceExcel?settleDateStart='
          + params.settleDateStart + '&settleDateEnd=' + params.settleDateEnd
          + '&endDateStart=' + params.endDateStart + '&endDateEnd=' + params.endDateEnd + '&userName='
          + params.userName + '&groupId=' + params.groupId + '&normalConfigId=' + params.normalConfigId + '&departmentId=' + params.departmentId,
        fileName: 'backPerformanceExcel.xls'
      }
      this.loading = true
      exportFile(file).catch(e => {
        this.$message.error(e.message)
      }).finally(() => {
        this.loading = false
      })
    },
    onChange(value) {
      console.log(value)
      getSysGroup({ 'departmentId': value }).then(res => {
        this.groupList = res.data || []
        this.queryParam.groupId = ''
      })
    }

  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>

